import { render } from "./CopySavedCard.vue?vue&type=template&id=5a539153"
import script from "./CopySavedCard.vue?vue&type=script&lang=js"
export * from "./CopySavedCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__